// Legacy self assessments (no assignee) keep this portal's old statuses, which
// mean something else in the new Bookkeeper Portal flow: an old
// READY_FOR_REVIEW was "Submitted to your accountant". Each is read as the
// new status it was saved for.
const newStatusByLegacyStatus = {
  PREPARING: 'PREPARING',
  OPEN: 'OPEN',
  READY_FOR_REVIEW: 'PREPARING_SUBMISSION', // Submitted to your accountant
  AWAITING_INFORMATION: 'AWAITING_APPROVAL', // Additional information requested
  PREPARING_SUBMISSION: 'PREPARING_SUBMISSION',
  AWAITING_APPROVAL: 'READY_FOR_REVIEW', // Review and Approval Requested
  READY_TO_FILE: 'READY_TO_FILE',
  SUBMITTED_TO_HMRC: 'SUBMITTED_TO_HMRC',
};

// Where a self assessment stands in the new Bookkeeper Portal flow, read the
// same way as the new portal (toEffectiveStatus there) so the two count alike.
const getEffectiveStatus = (selfAssessment) => {
  const { status, assignee, declarationConfirmed } = selfAssessment || {};

  if (!assignee) return newStatusByLegacyStatus[status] || status;

  // Signing the declaration only sets declarationConfirmed, so a signed final
  // review is ready to file whoever it's still with
  if (status === 'READY_FOR_REVIEW' && declarationConfirmed) {
    return 'READY_TO_FILE';
  }

  return status;
};

export default getEffectiveStatus;
